import { useCallback, useRef } from "react";

export function useFunctionRef<F extends Function>(f?: F): F {
    const ref = useRef(f);
    ref.current = f;

    return useCallback(
        ((...args: unknown[]) => {
            return ref.current?.apply(null, args);
        }) as unknown as F,
        [],
    );
}
